import React from 'react'
import { createViewArray } from "../templates/Templates"

export default ({ pageData, location, props, classname}) => {
  const viewData = pageData
  const views = createViewArray(viewData, location, props)
  return (
    <div className={(classname || "")}>
      {views.map((view) => { return view })}
    </div>
  )
}